import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
// import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt, FaMoneyBillWave } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { languageHelper } from "../../../config/helperFunctions";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/Modal/DeleteModal";
import Select from "react-select";

function Purchase() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Reference No") || "Reference No",
      accessorKey: "reference_no",
    },
    {
      header: languageHelper("Date") || "Date",
      accessorKey: "date",
    },
    {
      header: languageHelper("Supplier") || "Supplier",
      accessorKey: "supplier",
      cell: (row) => row.getValue().name,
    },
    {
      header: languageHelper("Amount") || "Amount",
      accessorKey: "sub_total",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "vat",
    },
    {
      header: languageHelper("G.Total") || "G.Total",
      accessorKey: "grand_total",
    },
    {
      header: languageHelper("Due") || "Due",
      accessorKey: "due",
    },
    {
      header: languageHelper("Added By") || "Added By",
      accessorKey: "user",
      cell: (row) => row.getValue().name,
    },
    {
      header: languageHelper("Actions") || "Actions",
      accessorKey: "total",
      cell: (row) => (
        <Dropdown
          id={row.row.original.id}
          options={dropdownOptions}
        />
      ),
    },
  ];

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState({
    date: new Date().toISOString().split("T")[0],
    amount: "",
    payment_method_id: "",
    note: "",
  });
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const handleDuePayment = (id) => {
    const purchase = data.find((item) => item.id === id);
    if (purchase) {
      setSelectedPurchase(purchase);
      setPaymentData((prev) => ({
        ...prev,
        amount: purchase.due,
      }));
      setShowPaymentModal(true);
    }
  };

  const handlePaymentChange = (e) => {
    setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
  };

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    const amount = parseFloat(paymentData.amount);
    const due = parseFloat(selectedPurchase?.due || 0);

    if (!amount || amount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    if (amount > due) {
      toast.error(`Amount cannot exceed the due amount (${due})`);
      return;
    }

    axios.put(`${apiKey}/api/rms/admin/purchase-payment/${selectedPurchase.id}`, paymentData, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    }).then(res => {
      toast.success(res.data.message || "Payment added successfully", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setShowPaymentModal(false);
      fetchData();
      setShowPaymentModal(false);
    })
      .catch(err => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
    // API call will be added later
    // toast.success("Payment validated successfully (API call pending)");
  };

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => navigate(`addPurchase/${id}`),
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => setDeleteId(id),
    },
    {
      name: languageHelper("Add Payment"),
      icon: <FaMoneyBillWave />,
      func: (id) => handleDuePayment(id),
      // show: (id) => {
      //   const item = data.find((d) => d.id === id);
      //   return item && parseFloat(item.due) > 0;
      // },
    },
  ];
  const buttonData = [
    {
      buttonText: languageHelper("Add Purchases") || "Add Purchases",
      path: "addPurchase",
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/purchase/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Deleted!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchData();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/purchase`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => { });
  }, [user?.token, user?.user.outlet_id]);
  useEffect(() => {
    fetchData();
    axios
      .get(`${apiKey}/api/rms/admin/get-all-payment`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setPaymentMethods(
          res.data.map((method, index) => {
            // if (method.id >= 5) return;
            return {
              label: method.name,
              value: method.id,
              index,
            };
          })
        );
      })
      .catch((err) => {
        console.log("Cannot load data");
      })
  }, [fetchData, user?.token]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Purchases") || "Purchases"}
        buttonData={buttonData}
      />
      {deleteId && (
        <DeleteModal
          setIsOpen={setDeleteId}
          onDelete={() => handleDelete(deleteId)}
        />
      )}

      {showPaymentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
          <div className="fixed inset-0 bg-black opacity-50"></div>
          <div className="relative w-full max-w-lg mx-auto my-6 z-50">
            <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
              <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                <h3 className="text-2xl font-semibold">
                  {languageHelper("Add Due Payment")}
                </h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => setShowPaymentModal(false)}
                >
                  <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowPaymentModal(false)}
                >
                  <RxCross1 />
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <form onSubmit={handlePaymentSubmit}>
                  <div className="grid grid-cols-1 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Date")}
                      </label>
                      <input
                        type="date"
                        name="date"
                        value={paymentData.date}
                        onChange={handlePaymentChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-d-bg focus:border-d-bg sm:text-sm"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Amount")}
                      </label>
                      <input
                        type="number"
                        name="amount"
                        value={paymentData.amount}
                        onChange={handlePaymentChange}
                        step="0.01"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-d-bg focus:border-d-bg sm:text-sm"
                        required
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {languageHelper("Due Amount")}: {selectedPurchase?.due}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Payment Method")}
                      </label>
                      <Select
                        type="text"
                        placeholder={languageHelper("Select")}
                        className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                        required
                        options={paymentMethods}
                        onChange={(e) =>
                          setPaymentData({
                            ...paymentData,
                            payment_method_id: e.value,
                          })
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Note")}
                      </label>
                      <textarea
                        name="note"
                        value={paymentData.note}
                        onChange={handlePaymentChange}
                        rows="3"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-d-bg focus:border-d-bg sm:text-sm"
                      ></textarea>
                    </div>
                  </div>
                  <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                    <button
                      className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowPaymentModal(false)}
                    >
                      {languageHelper("Close")}
                    </button>
                    <button
                      className="bg-d-bg text-white active:bg-d-bg font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      {languageHelper("Submit")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default Purchase;
